import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import React__default, { useId } from 'react';
import { CardContext } from './Card.context.esm.js';
import styles from './Card.styles.esm.js';
import { CardContent } from './components/CardContent.esm.js';
import { CardImage } from './components/CardImage.esm.js';
import { simulateButtonKeyboardBehavior } from '../../utils/buttonKeyboardBehavior.esm.js';
import { cn } from '../../utils/cn.esm.js';

const CardComponent = React__default.forwardRef((_a, ref) => {
    var { id: _id, className, inverse = false, variant = "standard", "aria-label": ariaLabel, onClick, children, interactive, href, imagePosition = "top" } = _a, props = __rest(_a, ["id", "className", "inverse", "variant", "aria-label", "onClick", "children", "interactive", "href", "imagePosition"]);
    const id = useId();
    const baseClass = styles({
        class: className,
        inverse,
        variant,
        imagePosition,
        interactive,
    });
    const Tag = React__default.useMemo(() => {
        if (!interactive)
            return "div";
        return href ? "a" : "button";
    }, [href, interactive]);
    const tabIndex = React__default.useMemo(() => {
        if (!interactive) {
            return undefined;
        }
        return 0;
    }, [interactive]);
    return (jsx(CardContext.Provider, { value: { imagePosition }, children: jsx(Tag, Object.assign({ ref: ref, id: _id !== null && _id !== void 0 ? _id : id, className: cn(baseClass.container(), className), tabIndex: tabIndex, "aria-label": interactive ? ariaLabel : undefined, onKeyDown: Tag === "button"
                ? simulateButtonKeyboardBehavior(onClick)
                : undefined, onClick: Tag === "button" ? onClick : undefined, href: Tag === "a" ? href : undefined }, props, { children: children })) }));
});
CardComponent.displayName = "Card";
CardImage.displayName = "CardImage";
CardContent.displayName = "CardContent";
const Card = CardComponent;
Card.Image = CardImage;
Card.Content = CardContent;

export { Card };
